import styled from "@emotion/styled";
import { css } from "@styled-system/css";
import shouldForwardProp from "@styled-system/should-forward-prop";
import { Property } from "node_modules/csstype";
import React from "react";
import {
  compose,
  justifyContent,
  JustifyContentProps,
  space,
  SpaceProps,
  variant,
} from "styled-system";

type Status = "error" | "warning" | "info";

type RootProps = SpaceProps &
  JustifyContentProps & {
    status?: Status;
    className?: string;
    whiteSpace?: Property.WhiteSpace;
    children: React.ReactNode;
  };

type Props = RootProps;

const Root = styled("div", {
  shouldForwardProp,
})<RootProps>(
  ({ theme, whiteSpace }) =>
    css({
      whiteSpace,
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-start",
      padding: `${theme.space.m} ${theme.space.l}`,
      borderRadius: theme.radii.default,
      [`@media ${theme.mediaQueries.tablet}`]: {
        fontSize: theme.fontSizes.s,
      },
    }),
  ({ theme }) =>
    compose(
      space,
      justifyContent,
      variant({
        prop: "status",
        variants: {
          error: css({
            backgroundColor: theme.colors.background.alert,
            border: theme.borders.alert,
          }),
          warning: css({
            backgroundColor: theme.colors.background.warning,
            border: theme.borders.warning,
          }),
          info: css({
            backgroundColor: theme.colors.background.info,
            border: theme.borders.info,
          }),
        },
      }),
    ),
);

const Content = styled("div")();

export const Alert: React.VFC<Props> = (props) => {
  const { children, status = "error", ...componentProps } = props;

  return (
    <Root {...componentProps} status={status}>
      <Content>{children}</Content>
    </Root>
  );
};
